export default "__VITE_ASSET__DYTKHYBK__"